import { SimpleFormattedMessageProps } from './simple-formatted-message.props'
import { FormattedMessage } from 'react-intl'

export const SimpleFormattedMessage = (props: SimpleFormattedMessageProps) => {
  return <FormattedMessage {...props.msgDescriptor} values={props.values} />
}
